import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { UserHome } from '@app/entities/interfaces/user/user-login.interface';
import { StorageService } from '@app/services/storage';
import { InternalRoute } from '@app/shared/helpers/route.helper';
import { Logger } from '@services/logger/logger.service';
import { NavigationEvent, NavigationEvents, NavigationService } from '@services/navigation/navigation.service';

import { AppManagerService } from '..';
import { AppStatus } from '../app/app.manager.service';
import { NavigationHelperService } from '../navigation/navigation.helper.service';

import { PAGES } from '@/enums/pages.enum';

@Injectable({
  providedIn: 'root'
})
export class ExworkersGuardService implements CanActivate {
  private readonly logger = new Logger('ExworkersGuardService');

  constructor(
    private navigationService: NavigationService,
    private storage: StorageService,
    private navigationHelperService: NavigationHelperService,
    private appManager: AppManagerService
  ) {}

  canActivate(): Promise<boolean> {
    return this.checkAccess();
  }

  private async checkAccess() {
    const canAccess = await this.checkUserHome();
    const eventType: NavigationEvents = NavigationEvents.SetRoot;
    const homeExworkersRoute: InternalRoute = { path: PAGES.HOME_EXWORKERS };

    if (!canAccess) {
      this.logger.error('User is exworker');

      if (this.appManager.status === AppStatus.INIT) {
        this.navigationHelperService.doRedirect(eventType, homeExworkersRoute);
      } else {
        const navEvent = new NavigationEvent(eventType, homeExworkersRoute);
        this.navigationService.navigate(navEvent);
      }
    }

    return canAccess;
  }

  private async checkUserHome(): Promise<boolean> {
    const userHome = await this.storage.getUserHome();
    const isExworker = userHome === UserHome.EXEMPLOYEE;
    return !isExworker;
  }
}
